<template>
    <div class="parent-container">
        <!-- <div class="content">
            <div class="service-provide-info">
                <div class="container text-center">
                    <h1 class="custom-text-color">Survey Completed</h1>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 text-center">
                    <div class="submit">
                        <button type="button" class="btn sub-main" @click="hispec()">Close</button>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
var { redirectUrl, frontHostName } = require("../../../config/config.js");
export default {
  name: "Thankyou",
  metaInfo() {
    return {
      title: this.siteTitle,
    };
  },
  props: ["siteTitle", "isLoopSurvey"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("previewSurvey", ["editResponseStatus"])
  },
  mounted() {
    // Added By Parimal A. Ghadiyali - 16th April 2021
    // As getting can't read property 'blur' of undefined in IE so we need to first active body element
    var bodyElement = document.querySelector("body");
    if(bodyElement.setActive) {
      bodyElement.setActive(); // For IE
    } else {
      if(bodyElement.focus) {
        bodyElement.focus(); // For other browsers
      }
    }
    this.$awn.modal(
      '<img src="/static/images/imgpsh_fullsize_anim.png" alt="...">',
      'custom-modal',
    );

    setTimeout(() => {
      var locat = frontHostName + process.env.CAKE_BASE_PATH + whiteLabel + '/formresponse/viewresponse/'+this.editResponseStatus.data.in_survey_id+"/"+this.editResponseStatus.data.in_response_id
      window.location.href = locat;
    }, 3000);
    // END
    if (this.editResponseStatus.flag == 1) {
      this.$awn.success("Form is updated!");
      var whiteLabel = location.href.split("/")[3];
      var locat = frontHostName + process.env.CAKE_BASE_PATH + whiteLabel + '/formresponse/viewresponse/'+this.editResponseStatus.data.in_survey_id+"/"+this.editResponseStatus.data.in_response_id
      console.log(locat);
      setTimeout(() => {
        window.location.href = locat;
      }, 3000);
    } else if (
      this.editResponseStatus.flag == 2 ||
      this.editResponseStatus.flag == 3
    ) {
      this.$awn.alert(
        this.editResponseStatus.errorDetails +
          ": There was some error in submitting repsponse. Please submit response again."
      );
    } else if (this.editResponseStatus.flag == 0) {
      this.$awn.alert(
        "There was some error in submitting repsponse. Please submit response again."
      );
    }
  },
  methods: {
  }
};
</script>



// WEBPACK FOOTER //
// src/components/EditResponse/Thankyou.vue